/**
 * @fileoverview gRPC-Web generated client stub for transporter_trailer
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.21.12
// source: protobuf/transporter_trailer/transporter_trailer.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as protobuf_model_merged_pb from '../../protobuf/model/merged_pb';
import * as protobuf_transporter_trailer_transporter_trailer_pb from '../../protobuf/transporter_trailer/transporter_trailer_pb';


export class TransporterTrailerServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorCreate = new grpcWeb.MethodDescriptor(
    '/transporter_trailer.TransporterTrailerService/Create',
    grpcWeb.MethodType.UNARY,
    protobuf_transporter_trailer_transporter_trailer_pb.CreateTransporterTrailerRequest,
    protobuf_model_merged_pb.TransporterTrailerResponse,
    (request: protobuf_transporter_trailer_transporter_trailer_pb.CreateTransporterTrailerRequest) => {
      return request.serializeBinary();
    },
    protobuf_model_merged_pb.TransporterTrailerResponse.deserializeBinary
  );

  create(
    request: protobuf_transporter_trailer_transporter_trailer_pb.CreateTransporterTrailerRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_model_merged_pb.TransporterTrailerResponse>;

  create(
    request: protobuf_transporter_trailer_transporter_trailer_pb.CreateTransporterTrailerRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.TransporterTrailerResponse) => void): grpcWeb.ClientReadableStream<protobuf_model_merged_pb.TransporterTrailerResponse>;

  create(
    request: protobuf_transporter_trailer_transporter_trailer_pb.CreateTransporterTrailerRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.TransporterTrailerResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/transporter_trailer.TransporterTrailerService/Create',
        request,
        metadata || {},
        this.methodDescriptorCreate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/transporter_trailer.TransporterTrailerService/Create',
    request,
    metadata || {},
    this.methodDescriptorCreate);
  }

  methodDescriptorUpdate = new grpcWeb.MethodDescriptor(
    '/transporter_trailer.TransporterTrailerService/Update',
    grpcWeb.MethodType.UNARY,
    protobuf_transporter_trailer_transporter_trailer_pb.UpdateTransporterTrailerRequest,
    protobuf_model_merged_pb.TransporterTrailerResponse,
    (request: protobuf_transporter_trailer_transporter_trailer_pb.UpdateTransporterTrailerRequest) => {
      return request.serializeBinary();
    },
    protobuf_model_merged_pb.TransporterTrailerResponse.deserializeBinary
  );

  update(
    request: protobuf_transporter_trailer_transporter_trailer_pb.UpdateTransporterTrailerRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_model_merged_pb.TransporterTrailerResponse>;

  update(
    request: protobuf_transporter_trailer_transporter_trailer_pb.UpdateTransporterTrailerRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.TransporterTrailerResponse) => void): grpcWeb.ClientReadableStream<protobuf_model_merged_pb.TransporterTrailerResponse>;

  update(
    request: protobuf_transporter_trailer_transporter_trailer_pb.UpdateTransporterTrailerRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.TransporterTrailerResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/transporter_trailer.TransporterTrailerService/Update',
        request,
        metadata || {},
        this.methodDescriptorUpdate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/transporter_trailer.TransporterTrailerService/Update',
    request,
    metadata || {},
    this.methodDescriptorUpdate);
  }

  methodDescriptorGet = new grpcWeb.MethodDescriptor(
    '/transporter_trailer.TransporterTrailerService/Get',
    grpcWeb.MethodType.UNARY,
    protobuf_transporter_trailer_transporter_trailer_pb.GetTransporterTrailersRequest,
    protobuf_transporter_trailer_transporter_trailer_pb.GetTransporterTrailersResponse,
    (request: protobuf_transporter_trailer_transporter_trailer_pb.GetTransporterTrailersRequest) => {
      return request.serializeBinary();
    },
    protobuf_transporter_trailer_transporter_trailer_pb.GetTransporterTrailersResponse.deserializeBinary
  );

  get(
    request: protobuf_transporter_trailer_transporter_trailer_pb.GetTransporterTrailersRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_transporter_trailer_transporter_trailer_pb.GetTransporterTrailersResponse>;

  get(
    request: protobuf_transporter_trailer_transporter_trailer_pb.GetTransporterTrailersRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_transporter_trailer_transporter_trailer_pb.GetTransporterTrailersResponse) => void): grpcWeb.ClientReadableStream<protobuf_transporter_trailer_transporter_trailer_pb.GetTransporterTrailersResponse>;

  get(
    request: protobuf_transporter_trailer_transporter_trailer_pb.GetTransporterTrailersRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_transporter_trailer_transporter_trailer_pb.GetTransporterTrailersResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/transporter_trailer.TransporterTrailerService/Get',
        request,
        metadata || {},
        this.methodDescriptorGet,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/transporter_trailer.TransporterTrailerService/Get',
    request,
    metadata || {},
    this.methodDescriptorGet);
  }

  methodDescriptorDelete = new grpcWeb.MethodDescriptor(
    '/transporter_trailer.TransporterTrailerService/Delete',
    grpcWeb.MethodType.UNARY,
    protobuf_transporter_trailer_transporter_trailer_pb.DeleteTransporterTrailersRequest,
    protobuf_transporter_trailer_transporter_trailer_pb.DeleteTransporterTrailersResponse,
    (request: protobuf_transporter_trailer_transporter_trailer_pb.DeleteTransporterTrailersRequest) => {
      return request.serializeBinary();
    },
    protobuf_transporter_trailer_transporter_trailer_pb.DeleteTransporterTrailersResponse.deserializeBinary
  );

  delete(
    request: protobuf_transporter_trailer_transporter_trailer_pb.DeleteTransporterTrailersRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_transporter_trailer_transporter_trailer_pb.DeleteTransporterTrailersResponse>;

  delete(
    request: protobuf_transporter_trailer_transporter_trailer_pb.DeleteTransporterTrailersRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_transporter_trailer_transporter_trailer_pb.DeleteTransporterTrailersResponse) => void): grpcWeb.ClientReadableStream<protobuf_transporter_trailer_transporter_trailer_pb.DeleteTransporterTrailersResponse>;

  delete(
    request: protobuf_transporter_trailer_transporter_trailer_pb.DeleteTransporterTrailersRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_transporter_trailer_transporter_trailer_pb.DeleteTransporterTrailersResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/transporter_trailer.TransporterTrailerService/Delete',
        request,
        metadata || {},
        this.methodDescriptorDelete,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/transporter_trailer.TransporterTrailerService/Delete',
    request,
    metadata || {},
    this.methodDescriptorDelete);
  }

  methodDescriptorList = new grpcWeb.MethodDescriptor(
    '/transporter_trailer.TransporterTrailerService/List',
    grpcWeb.MethodType.UNARY,
    protobuf_transporter_trailer_transporter_trailer_pb.ListTransporterTrailersRequest,
    protobuf_transporter_trailer_transporter_trailer_pb.ListTransporterTrailersResponse,
    (request: protobuf_transporter_trailer_transporter_trailer_pb.ListTransporterTrailersRequest) => {
      return request.serializeBinary();
    },
    protobuf_transporter_trailer_transporter_trailer_pb.ListTransporterTrailersResponse.deserializeBinary
  );

  list(
    request: protobuf_transporter_trailer_transporter_trailer_pb.ListTransporterTrailersRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_transporter_trailer_transporter_trailer_pb.ListTransporterTrailersResponse>;

  list(
    request: protobuf_transporter_trailer_transporter_trailer_pb.ListTransporterTrailersRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_transporter_trailer_transporter_trailer_pb.ListTransporterTrailersResponse) => void): grpcWeb.ClientReadableStream<protobuf_transporter_trailer_transporter_trailer_pb.ListTransporterTrailersResponse>;

  list(
    request: protobuf_transporter_trailer_transporter_trailer_pb.ListTransporterTrailersRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_transporter_trailer_transporter_trailer_pb.ListTransporterTrailersResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/transporter_trailer.TransporterTrailerService/List',
        request,
        metadata || {},
        this.methodDescriptorList,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/transporter_trailer.TransporterTrailerService/List',
    request,
    metadata || {},
    this.methodDescriptorList);
  }

  methodDescriptorExport = new grpcWeb.MethodDescriptor(
    '/transporter_trailer.TransporterTrailerService/Export',
    grpcWeb.MethodType.UNARY,
    protobuf_transporter_trailer_transporter_trailer_pb.ExportTransporterTrailersRequest,
    protobuf_transporter_trailer_transporter_trailer_pb.ExportTransporterTrailersResponse,
    (request: protobuf_transporter_trailer_transporter_trailer_pb.ExportTransporterTrailersRequest) => {
      return request.serializeBinary();
    },
    protobuf_transporter_trailer_transporter_trailer_pb.ExportTransporterTrailersResponse.deserializeBinary
  );

  export(
    request: protobuf_transporter_trailer_transporter_trailer_pb.ExportTransporterTrailersRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_transporter_trailer_transporter_trailer_pb.ExportTransporterTrailersResponse>;

  export(
    request: protobuf_transporter_trailer_transporter_trailer_pb.ExportTransporterTrailersRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_transporter_trailer_transporter_trailer_pb.ExportTransporterTrailersResponse) => void): grpcWeb.ClientReadableStream<protobuf_transporter_trailer_transporter_trailer_pb.ExportTransporterTrailersResponse>;

  export(
    request: protobuf_transporter_trailer_transporter_trailer_pb.ExportTransporterTrailersRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_transporter_trailer_transporter_trailer_pb.ExportTransporterTrailersResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/transporter_trailer.TransporterTrailerService/Export',
        request,
        metadata || {},
        this.methodDescriptorExport,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/transporter_trailer.TransporterTrailerService/Export',
    request,
    metadata || {},
    this.methodDescriptorExport);
  }

}

